<template>
    <div>
        <p>Loading...</p>
    </div>
</template>

<script>
   import { mapGetters } from "vuex";
   import data_getters from '../mixins/data_getters'


   export default {
      mixins: [data_getters],
      name: "auth-callback",
      methods: {

         // registered in plugins/auth.js
         async handleLoginEvent() {


            // set app colors based on agency
            let agency = await this.get_agencies();
            console.log(agency)

            this.$store.commit('setAppName', agency.app_settings.AppName);
            this.$store.commit('setAgencyLogo', '/static/' + agency.app_settings.AgencyLogo);
            this.$store.commit('setAgencyIcon', agency.app_settings.AgencyIcon);

            this.$store.dispatch("setColorScheme", agency.app_settings.ColorScheme);
            this.$store.dispatch("setNavDrawerScheme", agency.app_settings.DrawerScheme.navDrawerScheme);
            this.$store.dispatch("setNavToolbarScheme", agency.app_settings.DrawerScheme.navToolbarScheme);

            this.$vuetify.theme.primary = agency.app_settings.ColorScheme.secondary;
            this.$vuetify.theme.secondary = agency.app_settings.ColorScheme.secondary;
            this.$vuetify.theme.accent = agency.app_settings.ColorScheme.secondary;

            // push user back to original url once logged in
            // this.$router.push(data.state.target || "/");

            document.title = agency.app_settings.AppName;

            let link = document.querySelector("link[rel*='icon']"); // || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = agency.app_settings.AgencyIcon;

            console.log('auth call back ran')
         }
      },
      async created() {



         await this.handleLoginEvent();
         // this.$auth.redirect();
         let path = this.$auth.get_redirect();

         console.log('path', path)
         this.$router.push({path})

         // this.$auth.handleAuthentication();
      }
   }
</script>

<style scoped>

</style>